import { Transition } from 'components/Transition';
import { TransitionItem } from 'components/Transition';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { MediaUploadItem } from 'components/media/MediaUploadItem';
import './MediaUploadList.scss';
/**
 * @component MediaUploadList
 * @since 1.0.0
 */
export function MediaUploadList(props) {
    const { style, uploads } = Object.assign({ style: 'normal' }, props);
    const className = classNames('media-upload-list', 'media-upload-list--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(Transition, { sequent: false, enqueue: false }, uploads.map((upload) => (React.createElement(TransitionItem, { key: upload.id },
            React.createElement(MediaUploadItem, { upload: upload })))))));
}
